(function () {
  function visible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== "none" && style.visibility !== "hidden";
  }

  function closestBlock(el) {
    if (!el) return null;
    return el.closest("product-form, .product-form, .product-form__buttons, form") || el;
  }

  function hideDuplicateBuyAreas() {
    var forms = Array.from(document.querySelectorAll('product-form, form[action*="/cart/add"]'))
      .filter(function (el) {
        var text = (el.innerText || "").toLowerCase();
        return visible(el) && (text.includes("add to cart") || text.includes("buy it now"));
      });

    if (forms.length <= 1) return;

    var keeper = forms.find(function (el) {
      return (el.innerText || "").toLowerCase().includes("buy it now");
    }) || forms[forms.length - 1];

    forms.forEach(function (form) {
      if (form !== keeper) {
        var block = closestBlock(form);
        if (block && block !== keeper) {
          block.style.display = "none";
        }
      }
    });
  }

  function hideDuplicatePurchaseQuantityLabels() {
    var candidates = Array.from(document.querySelectorAll("legend, label, .form__label, .product-form__input"));
    var matched = candidates.filter(function (el) {
      var text = (el.innerText || el.textContent || "").trim().toLowerCase();
      return text === "purchase quantity" || text.includes("purchase quantity");
    });

    if (matched.length <= 1) return;

    matched.slice(1).forEach(function (el) {
      var block = el.closest("variant-radios, variant-selects, fieldset, .product-form__input") || el;
      block.style.display = "none";
    });
  }

  function addTrustBox() {
    if (document.querySelector(".wbg-trust-box")) return;

    var info =
      document.querySelector(".product__info-container") ||
      document.querySelector("product-info") ||
      document.querySelector(".product-information");

    if (!info) return;

    var trust = document.createElement("div");
    trust.className = "wbg-trust-box";
    trust.innerHTML = ''
      + '<div class="wbg-trust-title">Watch Box Guy Checkout</div>'
      + '<div class="wbg-trust-grid">'
      + '<div class="wbg-trust-item">Free shipping available</div>'
      + '<div class="wbg-trust-item">1 box or 10 box wholesale pack</div>'
      + '<div class="wbg-trust-item">Great for collectors, watch dealers, and jewelry stores</div>'
      + '<div class="wbg-trust-item">Secure online checkout</div>'
      + '</div>'
      + '<div class="wbg-urgent-note">Tip: choose 10 Box Wholesale Pack for the best bulk price.</div>';

    var price = info.querySelector(".price");
    if (price && price.parentNode) {
      price.parentNode.insertBefore(trust, price.nextSibling);
    } else {
      info.insertBefore(trust, info.firstChild);
    }
  }

  function runFixes() {
    if (!document.body || !document.body.className.toLowerCase().includes("template-product")) return;

    hideDuplicateBuyAreas();
    hideDuplicatePurchaseQuantityLabels();
    addTrustBox();
  }

  document.addEventListener("DOMContentLoaded", runFixes);
  document.addEventListener("shopify:section:load", runFixes);

  setTimeout(runFixes, 600);
  setTimeout(runFixes, 1500);
})();